import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f571b6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nav-list"
}
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.menuList.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (menu, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["nav-list-item", { 'active': _ctx.route.path === menu.link }]),
            onClick: ($event: any) => (_ctx.handleLink(menu)),
            key: index
          }, [
            _createElementVNode("span", null, _toDisplayString(menu.name), 1)
          ], 10, _hoisted_2)), [
            [_vShow, menu.show === undefined || menu.show]
          ])
        }), 128))
      ]))
    : _createCommentVNode("", true)
}